import React from "react";
import loaderGIF from "@frameworks/shared-library/assets/images/Reports/loaderGIF.gif";
import logoGIF from "@frameworks/shared-library/assets/images/generic/nuvama-loader.gif";
var Loader = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "b-overlay position-absolute outerdivloader ".concat(props.className ? props.className : "", " ") },
            React.createElement("div", { className: "position-absolute bg-light middleloader" }),
            React.createElement("div", { className: "position-absolute innerloader" },
                React.createElement("img", { src: loaderGIF })))));
};
export default Loader;
export var LogoLoader = function (props) {
    return (React.createElement("div", { className: "b-overlay position-fixed outerdivloader ".concat(props.className ? props.className : "", " ") },
        React.createElement("div", { className: "position-absolute  middleloader" }),
        React.createElement("div", { className: "position-absolute innerloader" },
            React.createElement("img", { src: logoGIF }))));
};
